import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'
import { SocAssessmentQuestionnaireItem } from 'components/Assessments/SocAssessment/types/questionnaire'
import { getAppointmentTimeWithTimezone } from 'components/Assessments/helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from 'components/Assessments/helpers.uncontrolled'

/**
 * Assessment Overview subsection adapter for SOC Assessment
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<SocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options?.caregiverTimezone
    )

    return {
      [SocFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const hasAppointmentTime = this.formDataFieldExists(
      SocFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME
    )
    const appointmentTimeField = hasAppointmentTime
      ? this.getFormDataField(SocFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME)
      : undefined

    const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(
      Array.isArray(appointmentTimeField) ? appointmentTimeField : [undefined, undefined]
    )

    return [
      {
        linkId: SocAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
        value: appointmentTimeValues.at(0)
      },
      {
        linkId: SocAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
        value: appointmentTimeValues.at(1)
      }
    ]
  }
}
